/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { CommentReactionSummary } from '../models/CommentReactionSummary';
import { SimpleUser } from '../models/SimpleUser';
import { HttpFile } from '../http/http';

export class Comment {
    'id': number;
    'dtCreated': Date;
    'dtModified': Date;
    'activity': number;
    'user': SimpleUser;
    'thread'?: number;
    'text': string;
    'reactionSummary': CommentReactionSummary;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "number",
            "format": ""
        },
        {
            "name": "dtCreated",
            "baseName": "dtCreated",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "dtModified",
            "baseName": "dtModified",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "activity",
            "baseName": "activity",
            "type": "number",
            "format": ""
        },
        {
            "name": "user",
            "baseName": "user",
            "type": "SimpleUser",
            "format": ""
        },
        {
            "name": "thread",
            "baseName": "thread",
            "type": "number",
            "format": ""
        },
        {
            "name": "text",
            "baseName": "text",
            "type": "string",
            "format": ""
        },
        {
            "name": "reactionSummary",
            "baseName": "reactionSummary",
            "type": "CommentReactionSummary",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return Comment.attributeTypeMap;
    }

    public constructor() {
    }
}

